<template>
  <table class="table" align="center" cellpadding="0" cellspacing="0">
    <thead class="thead">
      <tr align="center" class="thead_tr">
        <td v-if="serialNumber">序号</td>
        <td
          v-for="(item, ind) in tableHead"
          :key="ind"
          align="center"
          class="thead_td"
        >
          {{ item.text }}
        </td>
      </tr>
    </thead>
    <tbody v-if="tableData.length">
      <tr
        v-for="(item, index) in tableData"
        :key="index"
        :class="['tbody_tr', bt_none ? 'bt_none' : '']"
      >
        <td align="center"  v-if="serialNumber">{{ index + 1 }}</td>
        <td
          v-for="(content, i) in tableHead"
          :key="i"
          align="center"
          class="tbody_td"
          :rowspan="1"
        >
          <span> {{ item[content.props] }}</span>
          <!-- <span v-if="content.props">
            <span v-for="(value, key, idx) in content.props" :key="idx">
              {{ item[key] != 0 ? item[key] : ""
              }}{{ item[key] > 0 ? value : "" }}
            </span>
          </span>
          <span v-else>{{ item[content.prop] }}{{ content.unit }}</span> -->
        </td>
      </tr>
    </tbody>
    <tbody v-if="!tableData.length">
      <tr>
        <td class="pt_15" :colspan="tableHead.length" align="center">
          暂⽆数据
        </td>
      </tr>
    </tbody>
  </table>
</template>
<script>
export default {
  name: "tableCom",
  props: {
    tableHead: {
      type: Array,
      default() {
        return [];
      },
    },
    tableData: {
      type: Array,
      default() {
        return [];
      },
    },
    bt_none: {
      type: Boolean,
      default() {
        return false;
      },
    },
    serialNumber: {
      type: Boolean,
      default() {
        return false;
      },
    },
  },
};
</script>
<style lang="scss" scoped>
.table {
  min-width: 100%;
  border: 1px solid #ccc;
  .thead {
    height: 40px;
    line-height: 40px;
    border-bottom: 1px solid #d8d8d8;
    font-size: 12px;
    font-weight: 600;
    color: #a8a8a8;
  }
  tbody {
    tr {
      height: 40px;
      line-height: 40px;
      border-bottom: 1px solid #d8d8d8;
      td {
        span {
          max-height: 40px;
          max-width: 60px;
          padding: 0 10px;
        }
      }
    }
  }
}
</style>